module.exports = __webpack_public_path__ + "static/media/019admin_6 credit check result - accepted@2x.88463b71.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/optus/019admin_6 credit check result - accepted@2x.png
// module id = 584
// module chunks = 0